export default "__VITE_ASSET__KwZkaslO__"